import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authInitStateInactivity, logoutRequest } from 'redux/reducers/auth/reducer';
import { userInitState } from 'redux/reducers/user/reducer';
import { getAuthRefreshToken } from 'redux/reducers/auth/selectors';
import { PATHS } from 'routes/constants';
import { useNavigate } from 'react-router';
import { TScreensaverProps } from './types';
import { CircularProgressWithLabel } from './Progress';

const SCREENSAVER_TIMEOUT = 60; // 60

export const Screensaver: FC<TScreensaverProps> = ({ open, handleClose }) => {
	const refreshToken = useSelector(getAuthRefreshToken);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [progress, setProgress] = useState(0);

	useEffect(() => {
		// if (!open) return () => {};
		const timer = setInterval(() => {
			if (!open) return;
			setProgress((prevProgress) => (prevProgress >= SCREENSAVER_TIMEOUT ? 0 : prevProgress + 1));
			if (progress === SCREENSAVER_TIMEOUT) {
				// if (refreshToken) dispatch(logoutRequest({ token: refreshToken }));
				// dispatch(userInitState());
				// dispatch(authInitStateInactivity());
				clearInterval(timer);
				navigate(PATHS.INACTIVITY_PAGE);
				handleClose();
				setProgress(0);
			}
		}, 1000);
		return () => {
			clearInterval(timer);
		};
	}, [progress, dispatch, open, handleClose, refreshToken, navigate]);

	const handleIAmHere = () => {
		handleClose();
		setProgress(0);
	};

	return (
		<Dialog
			open={open}
			sx={{
				backdropFilter: 'blur(5px)',
				backgroundColor: '#01619589',
				'& .MuiDialog-paper': {
					backgroundColor: 'transparent',
					boxShadow: 'none',
				},
			}}
		>
			<DialogTitle variant="h4" color="#fff" id="alert-dialog-title">
				Are you still here?
			</DialogTitle>
			<DialogContent
				sx={{
					padding: 15,
				}}
			>
				{/* <CircularProgressWithLabel value={progress} /> */}
				<div
					style={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						fontSize: '60px',
						fontWeight: 'bold',
						color: SCREENSAVER_TIMEOUT - progress < 10 ? `#ff7fa4` : '#fff',
					}}
				>
					{SCREENSAVER_TIMEOUT - progress}
				</div>
			</DialogContent>
			<DialogActions disableSpacing sx={{ justifyContent: 'center' }}>
				<Button
					autoFocus
					variant="contained"
					size="large"
					sx={{
						color: '#fff',
						borderRadius: '50px',
						boxShadow: 'none',
						border: '1px solid #fff',
						fontSize: '20px',
						textTransform: 'none',
					}}
					onClick={handleIAmHere}
				>
					Yes, I am here
				</Button>
			</DialogActions>
		</Dialog>
	);
};
